// Dates of the planner as plain strings ("YYYY-MM-DD", "YYYY-MM-DDTHH:mm"
// in Paramaribo time, as the API speaks), computed in UTC so the browser's
// own time zone never shifts a day.

export const addDays = (date, n) => {
  const [y, m, d] = date.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
};

/** The Monday of the week a "YYYY-MM-DD" falls in */
export const mondayOf = (date) => {
  const [y, m, d] = date.split('-').map(Number);
  const weekday = (new Date(Date.UTC(y, m - 1, d)).getUTCDay() + 6) % 7;
  return addDays(date, -weekday);
};

/** The 7 days from a Monday */
export const weekDays = (monday) => Array.from({ length: 7 }, (_, i) => addDays(monday, i));

/** "Mon 12" in the reader's language */
export const dayLabel = (date, locale) => new Date(`${date}T12:00:00Z`)
  .toLocaleDateString(locale, { weekday: 'short', day: 'numeric', timeZone: 'UTC' });

/** "12 Oct – 18 Oct 2026" */
export const weekLabel = (monday, locale) => {
  const fmt = (date, opts) => new Date(`${date}T12:00:00Z`).toLocaleDateString(locale, { timeZone: 'UTC', ...opts });
  return `${fmt(monday, { day: 'numeric', month: 'short' })} – ${fmt(addDays(monday, 6), { day: 'numeric', month: 'short', year: 'numeric' })}`;
};

/** "HH:mm" of a "YYYY-MM-DDTHH:mm", with "+1" when it is the next day */
export const timeOf = (local, dayOfStart) => {
  const time = local.slice(11, 16);
  return local.slice(0, 10) > dayOfStart ? `${time} (+1)` : time;
};

/** The end date for a start date and times: the next day when the end time is not after the start */
export const endDateFor = (startDate, startTime, endTime) => (endTime <= startTime ? addDays(startDate, 1) : startDate);
